import { useState } from "react";
import { Mail, Loader2, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email address.");
      return;
    }
    setSending(true);
    try {
      const res = await axios.post(`${API}/newsletter`, { email, company });
      if (res.data.status === "already_subscribed") {
        toast.info("You're already subscribed!");
      } else {
        toast.success("Subscribed! Redirecting to our newsletter...");
        setEmail("");
        setCompany("");
        setTimeout(() => {
          window.open("https://www.jrtchidememedia.co.uk/newsletter", "_blank");
        }, 1500);
      }
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section
      data-testid="newsletter-section"
      className="relative py-16 md:py-20 bg-[#0d0d0d]/[0.93] border-t border-b border-[#c9a84c]/10"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12 lg:px-24 text-center">
        <div className="w-10 h-10 rounded-full bg-[#c9a84c]/10 border border-[#c9a84c]/25 flex items-center justify-center mx-auto mb-5">
          <Mail size={18} className="text-gold" />
        </div>
        <h3
          data-testid="newsletter-heading"
          className="font-heading text-2xl md:text-3xl font-medium text-white"
        >
          Stay <span className="text-gold">Compliance Ready</span>
        </h3>
        <p className="mt-3 text-sm text-zinc-500 max-w-md mx-auto">
          Get food safety tips, regulatory updates, and exclusive offers
          delivered straight to your inbox.
        </p>

        <form
          onSubmit={handleSubmit}
          data-testid="newsletter-form"
          className="mt-8 max-w-lg mx-auto space-y-3"
        >
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email address *"
            data-testid="newsletter-email"
            className="bg-white/5 border-[#c9a84c]/15 text-white placeholder:text-zinc-600 focus:ring-2 focus:ring-[#c9a84c]/50 focus:border-[#c9a84c]/40 text-center"
          />
          <Input
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            placeholder="Company / business name"
            data-testid="newsletter-company"
            className="bg-white/5 border-[#c9a84c]/15 text-white placeholder:text-zinc-600 focus:ring-2 focus:ring-[#c9a84c]/50 focus:border-[#c9a84c]/40 text-center"
          />
          <Button
            type="submit"
            disabled={sending}
            data-testid="newsletter-submit"
            className="w-full bg-gold hover:bg-[#b8963f] text-black py-3 text-sm font-semibold rounded transition-colors tracking-wide"
          >
            {sending ? (
              <Loader2 size={16} className="animate-spin mr-2" />
            ) : (
              <ArrowRight size={16} className="mr-2" />
            )}
            {sending ? "Subscribing..." : "Subscribe to Newsletter"}
          </Button>
        </form>

        <p className="mt-4 text-[10px] text-zinc-700">
          We respect your privacy. Unsubscribe anytime.
        </p>
      </div>
    </section>
  );
}
